export const MATERIAL_URL_CONSTS = {
  addMsg: 'Добавить',
  labelMsg: 'Ссылка на сюжет',
  wrongLinkMsg: 'Некорректная ссылка'
}
